export default __webpack_public_path__ + "static/john-goncalves-wlne-meet-the-candidates-c3faec561551c6b0b5a30aca1c32a637.webp";